import { auth } from '../../firebase/config';
import {
  signInWithEmailAndPassword,
  signOut as signOutFirebase,
  sendEmailVerification as sendEmailVerificationFirebase,
  sendPasswordResetEmail as sendPasswordResetEmailFirebase,
} from 'firebase/auth';

export const signIn = async (login: string, password: string) => {
  try {
    await signInWithEmailAndPassword(auth, login, password);
    return auth.currentUser;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const signOut = async () => {
  await signOutFirebase(auth);
  console.log('currentUser', auth.currentUser);
};

export const sendEmailVerification = async (user: any) => {
  await sendEmailVerificationFirebase(user);
};

export const sendPasswordResetEmail = async (email: string) => {
  await sendPasswordResetEmailFirebase(auth, email);
};
